import React, { useRef } from 'react'
import {
  Button, Row, Col,
} from 'antd'

import {
  LeftOutlined, RightOutlined,
} from '@ant-design/icons'

import { useScroll } from 'ahooks'
import { useIsSmallDevice } from '../../hookreducer/hooks'

import __ from '../../languages/parser'

import RecapMenu from './RecapMenu'

import {
  POT_HOLDER_URL, TOWEL_RACK_40_URL, TOWEL_RACK_60_URL, HOOKS_URL,
  FRAME_HOLDER_40_URL, VASE_HOLDER_10_URL, VASE_HOLDER_15_URL, COMPUTER_HOLDER_URL,
  HANGER_HOLDER_URL, GLASSES_RACKS_URL, WARDROBE_40_MENU_URL, WARDROBE_60_MENU_URL,
  WARDROBE_80_MENU_URL,
} from '../../static/url'


const ImageInsideButtonSmall = ({ src, alt, text }) => (
  <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
    <div style={{ margin: '0 4px' }}>
      <img src={src} style={{ height: '20px' }} alt={alt} />
    </div>
    <div style={{ margin: '0 14px' }}>
      {text}
    </div>
  </div>
)

const ImageInsideButton = ({
  src, alt, text,
}) => (
  <Row style={{ width: '100%' }}>
    <Col span={8} style={{ textAlign: 'center' }}>
      <img src={src} style={{ height: '24px' }} alt={alt} />
    </Col>
    <Col span={16} style={{ textAlign: 'left' }}>
      {text}
    </Col>
  </Row>
)

const AccessoriesMenuSmall = ({
  addElement,
}) => {
  const ref = useRef(null)
  const { left } = useScroll(ref)
  const maxScroll = ref.current ? ref.current.scrollWidth - ref.current.clientWidth : null

  const scrollLimit = left === 0 ? 'left' : left >= maxScroll - 1 ? 'right' : 'both'
  const setScroll = (direction) => {
    const stepScroll = direction === 'right' ? 100 : -100
    ref.current.scrollLeft += stepScroll
  }

  const accessoriesStyle = {
    marginBottom: '0.4em',
  }
  const SIZE = 'default'
  const MARGIN_BUTTON = '6px'

  const blocStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '10px',
    maxHeight: '84px',
    borderRadius: '12px',
    fontSize: '0.8em',
  }

  const blocStyleButtons = {
    marginTop: '4px',
    display: 'flex',
    flexDirection: 'row',
  }

  return (
    <Row>

      <Col span={1} style={{ fontSize: '0.8em', color: '#AAAAAA', lineHeight: '32px' }}>
        {scrollLimit === 'left' ? null
          : (
            <Button
              block
              type="text"
              size="small"
              style={{
                padding: 0, margin: 0, border: 'none', backgroundColor: 'none',
              }}
              onClick={() => setScroll('left')}
            >
              <LeftOutlined style={{ position: 'relative', top: '26px' }} />
            </Button>
          )}

      </Col>

      <Col offset={1} span={20}>
        <div
          style={{
            overflowX: 'scroll',
            overflowY: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            paddingBottom: '10px',
            height: '74px',
          }}
          ref={ref}
        >

          <div style={blocStyle}>
            <div>
              {__('Pot holder')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('potHolder_11_with_pot')}>
                <ImageInsideButtonSmall src={POT_HOLDER_URL} alt={__('Pot holder')} text="⌀11cm" />
              </Button>
              <Button size={SIZE} style={accessoriesStyle} onClick={() => addElement('potHolder_15')}>
                <ImageInsideButtonSmall src={POT_HOLDER_URL} alt={__('Pot holder')} text="⌀15cm" />
              </Button>
            </div>
          </div>

          <div style={blocStyle}>
            <div>
              {__('Vase holder')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('vaseHolder_10')}>
                <ImageInsideButtonSmall src={VASE_HOLDER_10_URL} alt={__('Vase holder')} text="10cm" />
              </Button>
              <Button size={SIZE} style={accessoriesStyle} onClick={() => addElement('vaseHolder_15')}>
                <ImageInsideButtonSmall src={VASE_HOLDER_15_URL} alt={__('Vase holder')} text="15cm" />
              </Button>
            </div>
          </div>

          <div style={blocStyle}>
            <div>
              {__('Frame holder')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('frameHolder_40')}>
                <ImageInsideButtonSmall src={FRAME_HOLDER_40_URL} alt={__('Frame holder')} text="40cm" />
              </Button>
            </div>
          </div>

          <div style={blocStyle}>
            <div>
              {__('Computer holder')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('computerHolder')}>
                <ImageInsideButtonSmall src={COMPUTER_HOLDER_URL} alt={__('Computer holder')} text={__('Computer holder')} />
              </Button>
            </div>
          </div>

          <div style={blocStyle}>
            <div>
              {__('Towel rack')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('ps40')}>
                <ImageInsideButtonSmall src={TOWEL_RACK_40_URL} alt={__('Towel rack')} text="40cm" />
              </Button>

              <Button size={SIZE} style={accessoriesStyle} onClick={() => addElement('ps60')}>
                <ImageInsideButtonSmall src={TOWEL_RACK_60_URL} alt={__('Towel rack')} text="60cm" />
              </Button>

            </div>
          </div>

          <div style={blocStyle}>
            <div>
              {__('Wardrobe')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('hangerHolder')}>
                <ImageInsideButtonSmall src={HANGER_HOLDER_URL} alt={__('Hanger holder')} text={__('Hanger holder')} />
              </Button>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('wardrobe40_with_hanger')}>
                <ImageInsideButtonSmall src={WARDROBE_40_MENU_URL} alt={`${__('Wardrobe')} 40cm`} text={`${__('Wardrobe')} 40cm`} />
              </Button>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('wardrobe60_with_hanger')}>
                <ImageInsideButtonSmall src={WARDROBE_60_MENU_URL} alt={`${__('Wardrobe')} 60cm`} text={`${__('Wardrobe')} 60cm`} />
              </Button>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('wardrobe80_with_hanger')}>
                <ImageInsideButtonSmall src={WARDROBE_80_MENU_URL} alt={`${__('Wardrobe')} 80cm`} text={`${__('Wardrobe')} 80cm`} />
              </Button>
            </div>
          </div>

          <div style={blocStyle}>
            <div>
              {__('Others')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...accessoriesStyle, marginRight: MARGIN_BUTTON }} onClick={() => addElement('hooks')}>
                <ImageInsideButtonSmall src={HOOKS_URL} alt={__('Hooks')} text={__('Hooks (x3)')} />
              </Button>
              <Button size={SIZE} style={accessoriesStyle} onClick={() => addElement('glassesHolder_with_glasses')}>
                <ImageInsideButtonSmall src={GLASSES_RACKS_URL} alt={__('glassesRacks')} text={__('Set of 3 glasses racks')} />
              </Button>
            </div>
          </div>

        </div>


      </Col>
      <Col offset={1} span={1} style={{ fontSize: '0.8em', color: '#AAAAAA', lineHeight: '32px' }}>
        {scrollLimit === 'right' ? null
          : (
            <Button
              block
              type="text"
              size="small"
              style={{
                padding: 0, margin: 0, border: 'none', backgroundColor: 'none',
              }}
              onClick={() => setScroll('right')}
            >
              <RightOutlined style={{ position: 'relative', top: '26px' }} />
            </Button>
          )}
      </Col>
    </Row>

  )
}

const AccessoriesMenu = ({
  addElement, setTag, isTagged, setQuotes, isQuotes, metalColor,
  woodColor, setMetalColor, setWoodColor,
}) => {
  const SIZE = 'default'
  const accessoriesStyle = {
    marginBottom: '0.4em',
    padding: 0,
  }

  return (
    <>
      <div className="maker-subtitle">
        {__('Pot holder')}
      </div>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('potHolder_11_with_pot')}>
        <ImageInsideButton src={POT_HOLDER_URL} alt={__('Pot holder')} text={__('Pot holder ⌀11cm')} />
      </Button>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('potHolder_15')}>
        <ImageInsideButton src={POT_HOLDER_URL} alt={__('Pot holder')} text={__('Pot holder ⌀15cm')} />
      </Button>
      <div>
        *
        {__('Pot sold separetly')}
      </div>

      <div className="maker-subtitle">
        {__('Vase holder')}
      </div>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('vaseHolder_10')}>
        <ImageInsideButton src={VASE_HOLDER_10_URL} alt={__('Vase holder 10cm')} text={__('Vase holder 10cm')} />
      </Button>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('vaseHolder_15')}>
        <ImageInsideButton src={VASE_HOLDER_15_URL} alt={__('Vase holder 15cm')} text={__('Vase holder 15cm')} />
      </Button>

      <div className="maker-subtitle">
        {__('Frame holder')}
      </div>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('frameHolder_40')}>
        <ImageInsideButton src={FRAME_HOLDER_40_URL} alt={__('Frame holder 40cm')} text={__('Frame holder 40cm')} />
      </Button>

      <div className="maker-subtitle">
        {__('Computer holder')}
      </div>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('computerHolder')}>
        <ImageInsideButton src={COMPUTER_HOLDER_URL} alt={__('Computer holder')} text={__('Computer holder')} />
      </Button>

      <div className="maker-subtitle" style={{ marginTop: '1em' }}>
        {__('Towel rack')}
      </div>

      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('ps40')}>
        <ImageInsideButton src={TOWEL_RACK_40_URL} alt={__('Towel rack')} text={__('Towel rack 40cm')} />
      </Button>

      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('ps60')}>
        <ImageInsideButton src={TOWEL_RACK_60_URL} alt={__('Towel rack')} text={__('Towel rack 60cm')} />
      </Button>

      <div className="maker-subtitle" style={{ marginTop: '1em' }}>
        {__('Wardrobe')}
      </div>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('hangerHolder')}>
        <ImageInsideButton src={HANGER_HOLDER_URL} alt={__('Hanger holder')} text={__('Hanger holder')} />
      </Button>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('wardrobe40_with_hanger')}>
        <ImageInsideButton src={WARDROBE_40_MENU_URL} alt={`${__('Wardrobe')} L.40cm`} text={`${__('Wardrobe')} L.40cm`} />
      </Button>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('wardrobe60_with_hanger')}>
        <ImageInsideButton src={WARDROBE_60_MENU_URL} alt={`${__('Wardrobe')} L.60cm`} text={`${__('Wardrobe')} L.60cm`} />
      </Button>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('wardrobe80_with_hanger')}>
        <ImageInsideButton src={WARDROBE_80_MENU_URL} alt={`${__('Wardrobe')} L.80cm`} text={`${__('Wardrobe')} L.80cm`} />
      </Button>


      <div className="maker-subtitle" style={{ marginTop: '1em' }}>
        {__('Others')}
      </div>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('hooks')}>
        <ImageInsideButton src={HOOKS_URL} alt={__('Hooks')} text={__('Hooks (x3)')} />
      </Button>
      <Button size={SIZE} style={accessoriesStyle} block onClick={() => addElement('glassesHolder_with_glasses')}>
        <ImageInsideButton src={GLASSES_RACKS_URL} alt={__('glassesRacks')} text={__('Set of 3 glasses racks')} />
      </Button>
      <RecapMenu
        setTag={setTag}
        isTagged={isTagged}
        setQuotes={setQuotes}
        isQuotes={isQuotes}
        metalColor={metalColor}
        woodColor={woodColor}
        setWoodColor={setWoodColor}
        setMetalColor={setMetalColor}
      />
    </>
  )
}

const AccessoriesMenuContainer = (props) => {
  const isSmall = useIsSmallDevice()
  return isSmall ? <AccessoriesMenuSmall {...props} /> : <AccessoriesMenu {...props} />
}
export default AccessoriesMenuContainer
